
import { defineComponent } from 'vue'
import IssueDetailMixin from '~/mixins/issueDetailMixin'

export default defineComponent({
  name: 'IgnoreIssueFilePattern',
  mixins: [IssueDetailMixin],
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    checkId: {
      type: String,
      default: ''
    },
    shortcode: {
      type: String,
      required: false
    },
    repositoryId: {
      type: String,
      default: ''
    },
    prLabel: {
      type: String,
      default: 'pull request'
    }
  },
  data() {
    return {
      pattern: '',
      isLoading: false
    }
  },
  computed: {
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {
        pattern: this.pattern
      } as {
        repositoryId?: string
        checkId?: string
        pattern: string
        issueShortcode?: string
        alsoCreateRule?: boolean
      }

      if (this.checkId) {
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
        params.alsoCreateRule = true
      } else {
        params.repositoryId = this.repositoryId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueFilePattern(params)
        this.$toast.success(`${this.issueShortcode} ignored for the specified file pattern.`)

        this.$emit('ignore', response.checkIssueIds)
      } catch (e) {
        this.$logErrorAndToast(
          e as Error,
          'Something went wrong while ignoring this issue, please contact support.',
          undefined,
          {
            context: 'Ignore Issue',
            params: {
              method: 'Ignore Issue File Pattern',
              ...params
            }
          }
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
